'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tone = require('tone');

var _tone2 = _interopRequireDefault(_tone);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var player_count = 2;
var sample_index = 0;

var compressor = new _tone2.default.Compressor(-30, 3).toMaster();

var samples = [{ root: 226, fn: 'samples/380737__cabled-mess__sansula-01-a-raw.mp3' }, { root: 267, fn: 'samples/380736__cabled-mess__sansula-02-c-raw.mp3' }, { root: 340, fn: 'samples/380735__cabled-mess__sansula-03-e-raw.mp3' }, { root: 452, fn: 'samples/380733__cabled-mess__sansula-06-a-02-raw.mp3' }];

samples.forEach(function (sample) {
  sample.players = [];
  sample.index = -1;
  for (var i = 0; i < player_count; i++) {
    var fn = sample.fn;
    if (window.location.href.match(/asdf.us/)) {
      fn = '//asdf.us/kalimba/' + fn;
    }
    var player = new _tone2.default.Player({
      url: fn,
      retrigger: true,
      playbackRate: 1
    });
    player.connect(compressor);
    sample.players.push(player);
  }
});

function play(freq) {
  var volume = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.0;

  var best = { sample: samples[sample_index] };
  sample_index = (sample_index + 1) % samples.length;
  best.sample.index = (best.sample.index + 1) % player_count;

  var player = best.sample.players[best.sample.index];
  player.playbackRate = freq / best.sample.root;
  // console.log(player)
  player.volume.value = volume;
  setTimeout(function () {
    player.start();
  }, 0);
}

exports.default = { play: play };


//////////////////
// WEBPACK FOOTER
// ./client/lib/kalimba.js
// module id = 66
// module chunks = 0